import BasicLayout from '@/layouts/basic-layout';

const meta = {
    auth: true
};

const pre = 'fisco-bcos-';

export default {
    path: '/fisco-bcos',
    name: 'FISCO BCOS',
    redirect: {
        name: `${pre}webase`
    },
    meta,
    component: BasicLayout,
    children: [
        {
            path: 'generator',
            name: `${pre}generator`,
            meta: {
                ...meta,
                title: '链管理',
                closable: true
            },
            component: () => import('@/pages/fisco-bcos/generator')
        },
        {
            path: 'webase',
            name: `${pre}webase`,
            meta: {
                ...meta,
                title: '区块浏览器',
                closable: true
            },
            component: () => import('@/pages/fisco-bcos/webase')
        },
        {
            path: 'front',
            name: `${pre}front`,
            hidden: true,
            meta: {
                ...meta,
                title: '节点管理',
                closable: true
            },
            component: () => import('@/pages/fisco-bcos/front')
        },
        {
            path: 'contract',
            name: `${pre}contract`,
            meta: {
                ...meta,
                title: '合约管理',
                closable: true
            },
            component: () => import('@/pages/fisco-bcos/contract')
        },
        {
            path: 'block',
            name: `${pre}block`,
            meta: {
                ...meta,
                title: '区块管理',
                closable: true
            },
            component: () => import('@/pages/fisco-bcos/block')
        },
        {
            path: 'transaction',
            name: `${pre}transaction`,
            meta: {
                ...meta,
                title: '交易管理',
                closable: true
            },
            component: () => import('@/pages/fisco-bcos/transaction')
        }

    ]
};
